import script from "./IconText.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconText.vue?vue&type=script&setup=true&lang=ts"

import "./IconText.vue?vue&type=style&index=0&id=05281cec&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05281cec"]])

export default __exports__